import { render, staticRenderFns } from "./DashboardFSOTasks.vue?vue&type=template&id=16545a45"
import script from "./DashboardFSOTasks.vue?vue&type=script&lang=js"
export * from "./DashboardFSOTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports